$(function() {
  
  var $html = $('html');

    $('#menu-link').click(function() {
      $html.toggleClass('menu_open');
    });

    $('.lazy').each(function() {

        var $el = $(this);
            $el.attr('srcset', $el.data('srcset')).removeClass('lazy');

    });

    $('.slideshow').each(function() {

        var $el = $(this);
        var $slides = $('.slide', this);
        var index_ = 1;
        var total_ = $slides.length;

        function shift_slideshow() {

            clearTimeout(timer_);

            var new_index_ = index_ + 1;

            if (new_index_ > total_) {
                new_index_ = 1;
            }

            $('.last_on', $el).removeClass('last_on');

            $slides.eq(index_ - 1).addClass('last_on').removeClass('on');
            $slides.eq(new_index_ - 1).addClass('on');

            index_ = new_index_;

            timer_ = setTimeout(shift_slideshow, 4000);

        };
      
	    if (total_ > 1) {
    	    var timer_ = setTimeout(shift_slideshow, 8000);
	    }

    });

});
